import { render, staticRenderFns } from "./SupportTab.vue?vue&type=template&id=81fb507e&scoped=true&"
import script from "./SupportTab.vue?vue&type=script&lang=js&"
export * from "./SupportTab.vue?vue&type=script&lang=js&"
import style0 from "./SupportTab.vue?vue&type=style&index=0&id=81fb507e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fb507e",
  null
  
)

export default component.exports